import type { ProjectId } from 'owa-timestream-types';
import getStore from './viewstate/store';

export function newOutlookSpaceDialogIsOpen() {
    const { isOpen, editProjectId } = getStore();
    return isOpen && !editProjectId;
}

export function editOutlookSpaceDialogIsOpen() {
    const { isOpen, editProjectId } = getStore();
    return isOpen && !!editProjectId;
}

export function getProjectPreviewId(): ProjectId | null {
    return getStore().projectPreviewId;
}
